import React from 'react'
import { codeBlock } from '@components/RichTextPlate/RichTextEditor.css'
import { PlateRenderElementProps } from '@udecode/plate-core/react'
import { Box } from '@ui'

import '../../prismTheme.css'

export const CodeBlockElement = React.forwardRef<HTMLElement>(
    (props: Partial<PlateRenderElementProps>, ref) => {
        return (
            <Box {...(props.attributes ?? {})} as="code" className={codeBlock}>
                {props.children}
            </Box>
        )
    },
)
